import { apiFetch } from './client';
import type { TermsTemplate } from '$lib/types';

// Read-only list — any authenticated user (the quote editor's "apply
// template" picker). Admin CRUD is separate (adminTermsTemplatesApi below).
export const termsTemplatesApi = {
  list: (vertical?: string) =>
    apiFetch<{ results: TermsTemplate[]; count: number }>(
      `/terms-templates${vertical ? `?vertical=${encodeURIComponent(vertical)}` : ''}`
    )
};

export const adminTermsTemplatesApi = {
  create: (body: Record<string, unknown>) =>
    apiFetch<TermsTemplate>('/admin/terms-templates', { method: 'POST', body: JSON.stringify(body) }),
  update: (id: number, body: Record<string, unknown>) =>
    apiFetch<TermsTemplate>(`/admin/terms-templates/${id}`, { method: 'PUT', body: JSON.stringify(body) }),
  remove: (id: number) => apiFetch<{ detail: string }>(`/admin/terms-templates/${id}`, { method: 'DELETE' })
};
